import { node } from "~/util/dom";
import Items, { IItemData } from "~/route/items";
import { getTripPOI } from "~/route/utils";
import WasmStoreMarker from "~/wasm/store/wasm-store-marker";

/**
 * Obal pro:
 * - planovani trasy po vode
 */
export default class ItemBoat {
	_parent: Items;

	_data: IItemData;

	_dom: {
		container: HTMLDivElement;
	};

	_layer: any;

	_wasmMarkers: Array<WasmStoreMarker>;

	constructor(parent:Items, data:IItemData) {
		this._parent = parent;
		this._data = data;
		this._dom = {
			container: node("div", { className: "route-item-boat" }),
		};
		this._layer = Mapy.getComponent("masakovac");
		this._wasmMarkers = [];

		this._build();
	}

	destroy() {
		this._dom.container.remove();

		for (const marker of this._wasmMarkers) {
			marker.destroy();
		}

		this._wasmMarkers.length = 0;
	}

	get container() {
		return this._dom.container;
	}

	// eslint-disable-next-line class-methods-use-this
	get state() {
		return null;
	}

	_build() {
		const poisCaption = node("h4", { textContent: this._data.poisTitle });
		const tripsBy = node("ul", { className: "trips-by" });

		this._data.pois.forEach(data => {
			const { li, wasmMarker } = getTripPOI(data, this._layer);

			tripsBy.appendChild(li);
			this._wasmMarkers.push(wasmMarker);
		});
		this._dom.container.appendChild(poisCaption);
		this._dom.container.appendChild(tripsBy);
	}
}
